export const API_URL = 'https://vivium-api.omneeyat.com/api'


